import type { Namespace } from '../types';

// DE drafted (anchors from the spec HTML: "Entfeuchter", "Dosierpumpe") — queued
// for native review in the task file's "DE review queue".
export const actuators = {
  title: { de: 'Aktoren', en: 'Actuators' },
  desc: {
    de: 'Live-Zustand von Pumpen, Lüftern, Licht und Ventilen am Standort. Ein/Aus-Steuerung in IoT Control.',
    en: 'Live state of pumps, fans, lights and valves across the site. On/off control lives in IoT Control.',
  },

  colActuator: { de: 'Aktor', en: 'Actuator' },
  colState: { de: 'Zustand', en: 'State' },
  channel: { de: 'Kanal', en: 'Channel' },

  on: { de: 'Ein', en: 'On' },
  off: { de: 'Aus', en: 'Off' },
  unknown: { de: 'Unbekannt', en: 'Unknown' },

  loadError: { de: 'Aktoren konnten nicht geladen werden', en: "Couldn't load actuators" },
  emptyTitle: { de: 'Noch keine Aktoren', en: 'No actuators yet' },
  emptyMsg: {
    de: 'Sobald ein Mikrocontroller, der einem Raum oder Rack zugewiesen ist, seine Aktorkanäle meldet, erscheinen sie hier mit Live-Zustand.',
    en: 'Once a microcontroller assigned to a room or rack reports its actuator channels, they appear here with live state.',
  },
} as const satisfies Namespace;
